import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import { Grid, Typography } from '@mui/material';
import AppModal from 'src/components/modal';
import staticData from '../../../resources/static.json';
import forms from '../../../resources/forms.json';
import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'src/store/hooks';
import { AppState, useAppDispatch } from 'src/store';
import { useUpdateDrugSupplyQuantityMutation, useUpdateDrugSupplyStatusMutation } from 'src/services/DrugSupply';
import { useUser } from 'src/components/hooks/useUser';
import { setMessage } from 'src/store/Message';
import { useUtil } from 'src/components/hooks/useUtil';
import { hideLoader, showLoader } from 'src/store/Loader';

const RequestToShipmentDialog: React.FunctionComponent<any> = props => {
  const { openRequestShipment, setOpenRequestShipment, openConfirm, setOpenConfirm, getRowsData } = props;
  const requestData = staticData.RequestToShipment.requestData;
  const formGroup = forms.requestToShipment;
  const confirmFormGroup = forms.confirmRequestToShipment;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const { formFields: confirmformField, rules: confirmRules } = getFormData(confirmFormGroup.groups);
  const { user } = useUser();
  const { handleError } = useUtil();
  const formRef: any = useRef(null);
  const { groups } = formFields;
  const { groups: confirmGroups } = confirmformField;
  const dispatch = useAppDispatch();
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const rowData: any = useAppSelector((state: AppState) => state.drugSupplySlice.drugSupplyRowData);
  const confirmData: any = useAppSelector((state: AppState) => state.drugSupplySlice.confirmSupplyData);
  const depotData = useAppSelector((state: AppState) => state.drugSupplySlice.depotsData);
  const [disableShipment, setDisableShipment] = useState<boolean>(true);
  const [
    updateDSquantityFunc,
    {
      data: updatedDSQuantityData,
      isSuccess: updatedDSQuantityIsSuccess,
      isError: updateDSquantityIsError,
      error: updateDSquantityError,
      isLoading: updateDSquantityIsLoading
    }
  ] = useUpdateDrugSupplyQuantityMutation();
  const [
    updateDStatusFunc,
    {
      data: updateDStatusData,
      isSuccess: updateDStatusIsSuccess,
      isError: updateDStatusIsError,
      error: updateDStatusError,
      isLoading: updateDStatusIsLoading
    }
  ] = useUpdateDrugSupplyStatusMutation();
  const handleCloseRequestShipment = () => {
    setOpenRequestShipment(false);
    setOpenConfirm(false);
  };
  const handlechange = async (key: string, value: any) => {
    if (key === 'transfer_quantity' && value) {
      if (value > Number(rowData?.quantity)) {
        groups?.map((obj: any) => {
          obj?.fields.map((field: any) => {
            if (field.name === 'transfer_quantity') {
              field.rules.custom.duplicateEntry = true;
            }
          });
        });
      } else {
        groups?.map((obj: any) => {
          obj?.fields.map((field: any) => {
            if (field.name === 'transfer_quantity') {
              field.rules.custom.duplicateEntry = false;
            }
          });
        });
      }
      setDisableShipment(false);
    }
  };
  const handleSave = () => {
    formRef.current.submit(onFormSubmit);
  };
  const onFormSubmit = (data: any) => {
    if (data.errors) {
      return;
    }
    if (data.success) {
      if (openConfirm) {
        handleConfirmDrugSupply(data);
      } else {
        handleRequestShipmentDrugSupply(data);
      }
    }
  };
  const handleRequestShipmentDrugSupply = (data: any) => {
    updateDSquantityFunc({
      drug_supply_id: rowData?.id,
      study_id: selectedStudy,
      application: process.env.REACT_APP_NAME,
      application_section: process.env.REACT_APP_TUDA_SLUG,
      application_module_section: process.env.REACT_APP_CONDUCT_NAME,
      data: {
        transfer_to: data.records?.transfer_to,
        transfer_quantity: data.records?.transfer_quantity,
        updated_by: user
      }
    });
  };
  const handleConfirmDrugSupply = (data: any) => {
    updateDStatusFunc({
      drug_supply_id: confirmData?.id,
      study_id: selectedStudy,
      application: process.env.REACT_APP_NAME,
      application_section: process.env.REACT_APP_TUDA_SLUG,
      application_module_section: process.env.REACT_APP_CONDUCT_NAME,
      data: {
        status: 'Shipped'
      }
    });
  };
  useEffect(() => {
    if (updateDSquantityIsError || updateDStatusIsError) {
      const err: any = updateDSquantityError ?? updateDStatusError;
      handleError(err);
    }
  }, [updateDSquantityIsError, updateDStatusIsError]);
  useEffect(() => {
    if (!updateDSquantityIsLoading && updatedDSQuantityData && updatedDSQuantityIsSuccess) {
      dispatch(
        setMessage({ msgDetails: 'Drug Supply has been successfully sent for Confirmation', severity: 'success' })
      );
      getRowsData();
      setOpenRequestShipment(false);
    }
  }, [updateDSquantityIsLoading, updatedDSQuantityIsSuccess]);
  useEffect(() => {
    if (!updateDStatusIsLoading && updateDStatusIsSuccess && updateDStatusData) {
      dispatch(setMessage({ msgDetails: 'Drug supply has been confirmed successfully', severity: 'success' }));
      getRowsData();
      setOpenConfirm(false);
    }
  }, [updateDStatusIsLoading, updateDStatusIsSuccess]);
  useEffect(() => {
    if (openRequestShipment) {
      groups?.map((obj: any) => {
        obj?.fields.map((field: any) => {
          if (field.name === 'transfer_to') {
            field.values =
              depotData
                ?.filter((ele: any) => ele.depot_id !== rowData?.depot_id)
                .map((depot: any) => `${depot.depot_name} - ${depot.depot_id}`) ?? [];
          }
        });
      });
    } else {
      groups?.map((obj: any) => {
        obj?.fields.map((field: any) => {
          if (field.name === 'transfer_to') {
            field.values = [];
          }
        });
      });
    }
  }, [openRequestShipment]);
  useEffect(() => {
    if (updateDSquantityIsLoading || updateDStatusIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [updateDStatusIsLoading, updateDSquantityIsLoading]);

  return (
    <>
      <AppModal
        open={openRequestShipment || openConfirm}
        title={openConfirm ? confirmFormGroup.header : formGroup.header}
        saveButton={openConfirm ? 'Confirm' : 'Request Shipment'}
        closeButton={'Cancel'}
        handleSubmit={handleSave}
        handleClose={() => handleCloseRequestShipment()}
        maxWidth="600px"
        disabled={openRequestShipment && disableShipment}
        outSideClickClose
      >
        <Loader />
        {openRequestShipment && (
          <Typography
            variant="body1"
            mb="24px"
            sx={{ fontSize: 'clamp(13px, 14px, 16px)', mt: -1.75, fontWeight: 500 }}
          >
            Ship <strong>{rowData?.investigational_drug}</strong> from <strong>{rowData?.depot_name}</strong>
          </Typography>
        )}

        <Grid container spacing={2} rowSpacing={1} mb="24px">
          {requestData.map((ele: any, index: number) => (
            <Grid item md={6} key={index}>
              <Typography variant="body1" sx={{ fontSize: 'clamp(14px, 15px, 16px)', wordBreak: 'break-word' }}>
                <strong style={{ display: 'inline-block', minWidth: 'fit-content' }}>{ele.textValue}:&nbsp;</strong>
                <span className="results">{openConfirm ? confirmData?.[ele.value] : rowData?.[ele.value]}</span>
              </Typography>
            </Grid>
          ))}
        </Grid>
        <FormLayoutBuilder
          initialValues={openConfirm ? confirmData : defaultValues}
          rules={openConfirm ? confirmRules : rules}
          ref={formRef}
          groups={openConfirm ? confirmGroups : groups}
          onChange={(key: string, value: any) => handlechange(key, value)}
          columnSpacing={2}
        />
        <br />
        <br />
      </AppModal>
    </>
  );
};

export default RequestToShipmentDialog;
